import { Typography, TextField, Snackbar } from "@material-ui/core";
import { useEffect, useState, useRef, useReducer } from "react";
import { useLocation, useHistory } from "react-router";
import { format } from 'date-fns';
import api from "../api";
import CloseImage from '../../assets/ic_close.png';
import CustomTextField from '../components/customTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import icCircle from '../../assets/circle.png';
import icSeru from '../../assets/ic_exclamation.png';
import Loader from 'react-loader-spinner'
import NumberFormat from 'react-number-format';
import { formatCurrency } from "../../library/Util";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { ComponentKwitansi } from './ComponentKwitansi';
import { ComponentTransaksi } from './ComponentTransaksi';

const pageStyle = `{size: 15.7cm 22.2cm}`;

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

export default function DetailPembayaran(props) {
    const componentKwitansi = useRef()
    const componentTransaksi = useRef()
    const location = useLocation()
    const history = useHistory()
    const [data, setData] = useState(null)
    const [datakuitansi, setDataKuitansi] = useState(null)
    const [tglTransaksi, setTglTransaksi] = useState("")
    const [tglPayment, setTglPayment] = useState('')
    const [loading, setLoading] = useState(false)
    const [view, setView] = useState(false)
    const [visiblePelunasan, setVisiblePelunasan] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState(null)
    const [listPaymentMethod, setListPaymentMethod] = useState([])
    const [keterangan, setKeterangan] = useState("")
    const [totalPelunasan, setTotalPelunasan] = useState("")
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [visibleConfirm, setVisibleConfirm] = useState(false)
    const [visibleVoid, setVisibleVoid] = useState(false)
    const [visibleKuitansi, setVisibleKuitansi] = useState(false)
    const [errorAmount, setErrorAmount] = useState(false);
    const [texterrorAmount, setTextErrorAmount] = useState(null);
    const [errorPaymentMethod, setErrorPaymentMethod] = useState(false);
    const [texterrorPaymentMethod, setTextErrorPaymentMethod] = useState(null);

    const forceUpdate = useReducer(bool => !bool)[1];

    useEffect(() => {
        getDetail()
        getPaymentMethod()
        getDetailKuitansi()
    }, [])

    const getDetail = () => {
        api.create().getPembayaranDetail(location.state.data[11]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setTglTransaksi(String(response.data.data.transaction_date))
                    response.data.data.payment_date ? setTglPayment(String(response.data.data.payment_date)) : setTglPayment('')
                    setData(response.data.data)
                    setView(true)
                    console.log(String(response.data.data.transaction_date));
                }
            }
        })
    }

    const getDetailKuitansi = () => {
        api.create().getDetailKuitansi(location.state.data[11]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setDataKuitansi(response.data.data)
                    setVisibleKuitansi(true)
                    forceUpdate()
                } else {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("warning")
                }
            }
        })
    }

    const getPaymentMethod = () => {
        api.create().getListPaymentMethod().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        setListPaymentMethod(response.data.data)
                    }
                }
            }
        })
    }

    const handleSave = () => {

        if (totalPelunasan === "") {
            setErrorAmount(true)
            setTextErrorAmount("Total pelunasan wajib diisi")
        } else if (paymentMethod === null) {
            setErrorPaymentMethod(true)
            setTextErrorPaymentMethod("Metode Pembayaran wajib diisi")
        } else {
            let payment = [
                {
                    "type": 1,
                    "name": paymentMethod && paymentMethod.name,
                    "price": Number(totalPelunasan)
                }
            ]
            if (data.payment_guarantor !== "0") {
                payment.push({
                    "type": 2,
                    "name": "Asuransi",
                    "price": Number(data.payment_guarantor)
                })
            }
            let payload = {
                "total_payment": Number(data.payment_guarantor) + Number(totalPelunasan),
                "notes": keterangan,
                "billing": [
                    {
                        "bill_code": data.transaction_code_medapp,
                        "paid": Number(data.payment_guarantor) + Number(totalPelunasan),
                        "payment_method_id": paymentMethod && paymentMethod.id,
                        "payment": payment
                    }
                ]
            }

            if (data.appointment_id !== null) {
                payload = {
                    ...payload,
                    "appointment_id": data.appointment_id,
                }
            }

            console.log(JSON.stringify(payload));

            api.create().createPayment(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        history.goBack()
                    } else {
                        setOpenAlert(true)
                        setMessageAlert(JSON.stringify(response.data.data))
                        setStatusAlert("warning")
                    }
                }
            })

        }
    }

    const handleCancelBill = () => {
        console.log(data);
        let payload = {
            "code": data.transaction_code_medapp,
        }

        if (data.appointment_id === null) {
            payload = {
                ...payload,
                "is_appointment": 0,
            }
        } else {
            payload = {
                ...payload,
                "is_appointment": 1,
                "appointment_id": data.appointment_id,
            }
        }
        console.log(JSON.stringify(payload));
        api.create().cancelBill(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    history.goBack()
                } else {
                    setOpenAlert(true)
                    setMessageAlert(JSON.stringify(response.data.data))
                    setStatusAlert("warning")
                }
            }
        })
    }

    const handleVoid = () => {
        console.log(data);
        setLoading(true)
        let payload = {
            "bill_id": data.id,
            "payment_id": data.payment_id
        }
        if (data.appointment_id === null) {
            payload = {
                ...payload,
                "is_appointment": 0,
            }
        } else {
            payload = {
                ...payload,
                "is_appointment": 1,
                "appointment_id": data.appointment_id,
            }
        }
        console.log(JSON.stringify(payload));
        api.create().voidPayment(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    getDetail()
                    setVisibleVoid(false)
                } else {
                    setOpenAlert(true)
                    setMessageAlert(JSON.stringify(response.data.data))
                    setStatusAlert("warning")
                }
            }
        })
        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    const handleSeparator = (string) => {
        let val = string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return val
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ padding: '20px 30px', width: '100%', maxHeight: location.state.height - 80, overflow: 'scroll' }}>
            {loading && (loadingComponent)}
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {view && (
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 20 }}>Data Transaksi Pasien</Typography>
                        {data.bill_status_code && data.bill_status_code !== 0 && data.bill_status_code !== 5 ?
                            <div
                                style={{ paddingRight: 20, cursor: 'pointer' }}
                                onClick={() => {
                                    setVisiblePelunasan(true)
                                    setTotalPelunasan(data.payment_personal)
                                }}
                            >
                                <Typography style={{ color: '#0066ff', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16 }}>+ Pelunasan Pembayaran</Typography>
                            </div>
                            :
                            null
                        }

                    </div>
                    <div style={{ marginTop: 20, padding: '0px 30px', display: 'flex', width: '100%' }}>
                        <div style={{ width: '25%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12 }}>Kode Transaksi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.transaction_code_medapp === null ? "-" : data.transaction_code_medapp}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Kode Reservasi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.booking_code === null ? "-" : data.booking_code}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Metode Pembayaran</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.payment_method === null ? "-" : data.payment_method}</Typography>
                            {/* <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 14, marginTop: 15 }}>Referensi Pembayaran</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18 }}>{data.payment_reference === null ? "-" : data.payment_reference}</Typography> */}

                        </div>
                        <div style={{ width: '30%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12 }}>Tanggal Transaksi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{tglTransaksi}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Opsi Pembayaran</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.payment_option_desc === "Unknown" ? "-" : data.payment_option_desc}</Typography>
                            {/* <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 14, marginTop: 15 }}>Status Pembayaran Online</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18 }}>{data.payment_status}</Typography> */}
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Tanggal Pembayaran</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{tglPayment === '' ? '-' : tglPayment}</Typography>
                            {/* <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 14, marginTop: 15 }}>Catatan Referensi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18 }}>{data.reference_notes === "" ? "-" : data.reference_notes}</Typography> */}
                        </div>
                        <div style={{ width: '35%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12 }}>No. Rekam Medis</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.medical_record_no === null || data.medical_record_no === "" ? "-" : data.medical_record_no}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Provider Asuransi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.provider_penjamin === null ? "-" : data.provider_penjamin}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Status Pembayaran HIS</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.bill_status}</Typography>
                        </div>
                        <div style={{ width: '25%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12 }}>Nama Pasien</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.patient_name === null ? data.bill_owner : data.patient_name}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>No. kartu</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.provider_penjamin_no === null ? '-' : data.provider_penjamin_no}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 12, marginTop: 15 }}>Kode Transaksi HIS</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>{data.transaction_code_client === null ? '-' : data.transaction_code_client}</Typography>
                        </div>
                    </div>
                    <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 20, marginTop: 20 }}>Detail Transaksi Pasien</Typography>
                    {data.detail.length > 0 && data.detail.map((item, index) => {
                        return (
                            <div>
                                {item.type_detail.map((i, idx) => {
                                    let total = 0
                                    total = Number(i.price) * Number(i.quantity)
                                    return (
                                        <div style={{ marginTop: idx === 0 ? 20 : 0, padding: '0px 30px', width: '100%', }}>
                                            {idx === 0 ?
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: 'bold', fontSize: 18 }}>{item.type}</Typography>
                                                    <span style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16 }}>{item.code}</span>
                                                </div>
                                                : null}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                <div style={{ width: '50%' }}>
                                                    {idx === 0 ? <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Nama Item</Typography> : null}
                                                    <Typography style={{ color: '#3d3d3d', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16 }}>{i.name}</Typography>
                                                </div>
                                                <div style={{ width: '25%' }}>
                                                    {idx === 0 ? <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Qty</Typography> : null}
                                                    <Typography style={{ color: '#3d3d3d', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16 }}>{i.quantity}</Typography>
                                                </div>
                                                <div style={{ width: '25%' }}>
                                                    {idx === 0 ? <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Amount</Typography> : null}
                                                    <Typography style={{ color: '#3d3d3d', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16 }}>Rp. {formatCurrency(i.price)}</Typography>
                                                </div>
                                                <div style={{ width: '25%' }}>
                                                    {idx === 0 ? <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14, textAlign: 'right' }}>Jumlah</Typography> : null}
                                                    <Typography style={{ color: '#3d3d3d', fontFamily: 'Poppins', fontWeight: '500', fontSize: 16, textAlign: 'right' }}>Rp. {formatCurrency(total)}</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        )
                    })}
                    <div style={{ marginTop: 20, padding: '0px 30px', display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                        <div>
                            <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18 }}>Total Pembayaran</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Discount</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Biaya yang dibayarkan oleh perusahaan/asuransi</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Biaya yang di tanggung pribadi</Typography>
                            {/* <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14 }}>Biaya delivery (pengiriman obat)</Typography> */}
                        </div>
                        <div>
                            <Typography style={{ color: '#278863', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18 }}>Rp. {formatCurrency(data.total_price)}</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14, textAlign: 'right' }}>{data.discount}</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14, textAlign: 'right' }}>Rp. {formatCurrency(data.payment_guarantor === null ? 0 : data.payment_guarantor)}</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14, textAlign: 'right' }}>Rp. {formatCurrency(data.payment_personal === null ? 0 : data.payment_personal)}</Typography>
                            {/* <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 14, textAlign: 'right' }}>{data.delivery}</Typography> */}
                        </div>
                    </div>
                    <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18, marginTop: 30 }}>Status</Typography>
                    {/* {data.length > 0 && data.map((item, index) => {
                        return ( */}
                    <div style={{ marginTop: 20, padding: '0px 30px', display: 'flex', width: '100%' }}>
                        <div style={{ width: '25%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Bill Created By</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.created_by}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Payment Created By</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.payment_created_by === null ? "-" : data.payment_created_by}</Typography>

                        </div>
                        <div style={{ width: '30%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Bill Created At</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.transaction_date}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Payment Created At</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.payment_created_at === null ? "-" : data.payment_created_at}</Typography>
                        </div>
                        <div style={{ width: '35%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Bill Updated By</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.updated_by === null ? "-" : data.updated_by}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Payment Updated By</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.payment_updated_by === null ? "-" : data.payment_updated_by}</Typography>
                        </div>
                        <div style={{ width: '25%' }}>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Bill Updated At</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.updated_at === null ? "-" : data.updated_at}</Typography>
                            <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Payment Updated At</Typography>
                            <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{data.payment_updated_at === null ? "-" : data.payment_updated_at}</Typography>
                        </div>
                    </div>
                    {/* )
                    })} */}


                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', marginTop: 60 }}>
                            <div>
                                <ReactToPrint
                                    pageStyle={pageStyle}
                                    trigger={() => {
                                        return (
                                            <div
                                                style={{ backgroundColor: '#519d6d', width: 165, marginRight: 10, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer', marginRight: 10 }}
                                            >
                                                <Typography style={{ color: '#ffffff' }}>Cetak Transaksi</Typography>
                                            </div>
                                        )
                                    }}
                                    content={() => componentTransaksi.current}
                                >
                                    <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Transaksi</Typography>
                                </ReactToPrint>
                                <div style={{ display: 'none' }}>
                                    <ComponentTransaksi
                                        data={data}
                                        // noAntrian={rowData[1]}
                                        // kodePesanan={rowData[3]}
                                        // namaPasien={rowData[4]}
                                        // status={rowData[6]}
                                        // medicalRecord={rowData[9]}
                                        // lokasi={lokasi}
                                        // detailResep={detailResep}
                                        // tipeAntrian={this.state.tipeAntrian}
                                        // regisAntrian={this.state.regisAntrian}
                                        ref={componentTransaksi}
                                    />
                                </div>
                            </div>
                            {data.bill_status_code && data.bill_status_code === 5 && visibleKuitansi ?
                                <div>
                                    <ReactToPrint
                                        pageStyle={pageStyle}
                                        trigger={() => {
                                            return (
                                                <div
                                                    style={{ backgroundColor: '#519d6d', width: 165, marginRight: 10, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                                                >
                                                    <Typography style={{ color: '#ffffff' }}>Cetak Kuitansi</Typography>
                                                </div>
                                            )
                                        }}
                                        content={() => componentKwitansi.current}
                                    >
                                        <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Kuitansi</Typography>
                                    </ReactToPrint>
                                    <div style={{ display: 'none' }}>
                                        <ComponentKwitansi
                                            datakuitansi={datakuitansi}
                                            // noAntrian={rowData[1]}
                                            // kodePesanan={rowData[3]}
                                            // namaPasien={rowData[4]}
                                            // status={rowData[6]}
                                            // medicalRecord={rowData[9]}
                                            // lokasi={lokasi}
                                            // detailResep={detailResep}
                                            // tipeAntrian={this.state.tipeAntrian}
                                            // regisAntrian={this.state.regisAntrian}
                                            ref={componentKwitansi}
                                        />
                                    </div>
                                </div>
                                :
                                null
                            }

                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 60 }}>
                            {data.bill_status_code === 2 || data.bill_status_code === 3 ? (
                                <div
                                    style={{ backgroundColor: 'transparent', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', border: '2px solid #909090', textAlign: 'center', padding: '0 20px', display: 'flex', alignItems: 'center' }}
                                    onClick={() => {
                                        setVisibleConfirm(true)
                                        // console.log(content);
                                        // console.log(String(content).indexOf("*"));
                                    }}>
                                    <Typography style={{ color: 'black' }}>Batalkan Pembayaran</Typography>
                                </div>
                            ) : null}
                            {data.bill_status_code === 4 || data.bill_status_code === 5 || data.bill_status_code === 6 ? (
                                <div
                                    style={{ backgroundColor: '#bdbdbd', width: 210, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                                    onClick={() => {
                                        setVisibleVoid(true)
                                        // console.log(content);
                                        // console.log(String(content).indexOf("*"));
                                    }}>
                                    <Typography style={{ color: 'white' }}>Void Pembayaran</Typography>
                                </div>
                            )
                                : null
                            }
                        </div>
                    </div>
                </div>

            )
            }
            {
                visiblePelunasan && (
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18, }}>Input Pelunasan</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => setVisiblePelunasan(false)}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                                <div className="column-1">
                                    <div style={{ margin: 0 }}>
                                        <Autocomplete
                                            options={listPaymentMethod}
                                            disableClearable={true}
                                            getOptionLabel={(option) => option.name}
                                            style={{ width: '100%' }}
                                            onChange={(event, newInputValue) => {
                                                setPaymentMethod(newInputValue)
                                                setErrorPaymentMethod(false)
                                                setTextErrorPaymentMethod("")
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    required={true}
                                                    error={errorPaymentMethod}
                                                    helperText={texterrorPaymentMethod}
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                                    label={'Metode Pembayaran'}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="column-2" style={{ textAlign: 'left' }}>
                                    <CustomTextField
                                        label="Keterangan"
                                        onChange={(e) => setKeterangan(e)}
                                    />
                                </div>
                                <div className="column-1" style={{ textAlign: 'left' }}>
                                    <CustomTextField
                                        required={true}
                                        error={errorAmount}
                                        helperText={texterrorAmount}
                                        label="Total Pelunasan"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                        onChange={(e) => {
                                            setTotalPelunasan(e)
                                            setErrorAmount(false)
                                            setTextErrorAmount("")
                                        }}
                                        defaultValue={data.payment_personal}
                                    />
                                </div>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => handleSave()}
                                        style={{ height: 32, width: 150, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                visibleConfirm && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle" style={{ borderRadius: 15, width: 540, backgroundColor: '#f2fff9' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ backgroundColor: '#f2fff9', margin: '-50px 0px 0px 0px', borderRadius: 70, width: 115, height: 115, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ backgroundImage: `url(${icCircle})`, width: 103.8, height: 103.8, backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img src={icSeru} style={{ width: 50, height: 50 }} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin membatalkan pembayaran pada transaksi ini?</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '10px', padding: '20px' }}>
                                <div
                                    onClick={() => setVisibleConfirm(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => handleCancelBill()}
                                    style={{ height: 32, width: 150, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                visibleVoid && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle" style={{ borderRadius: 15, width: 540, backgroundColor: '#f2fff9' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ backgroundColor: '#f2fff9', margin: '-50px 0px 0px 0px', borderRadius: 70, width: 115, height: 115, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ backgroundImage: `url(${icCircle})`, width: 103.8, height: 103.8, backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img src={icSeru} style={{ width: 50, height: 50 }} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin menangguhkan pembayaran pada transaksi ini?</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '10px', padding: '20px' }}>
                                <div
                                    onClick={() => setVisibleVoid(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => handleVoid()}
                                    style={{ height: 32, width: 150, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    )
}